var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestFlask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7835 18.7284L15 9.08625V3.75H15.75C15.9489 3.75 16.1397 3.67098 16.2804 3.53033C16.421 3.38968 16.5 3.19891 16.5 3C16.5 2.80109 16.421 2.61032 16.2804 2.46967C16.1397 2.32902 15.9489 2.25 15.75 2.25H8.25002C8.05111 2.25 7.86034 2.32902 7.71969 2.46967C7.57904 2.61032 7.50002 2.80109 7.50002 3C7.50002 3.19891 7.57904 3.38968 7.71969 3.53033C7.86034 3.67098 8.05111 3.75 8.25002 3.75H9.00002V9.08625L3.21658 18.7284C3.08018 18.9558 3.0065 19.2154 3.00306 19.4805C2.99961 19.7457 3.06652 20.007 3.19697 20.2379C3.32741 20.4688 3.51673 20.6609 3.74563 20.7948C3.97454 20.9287 4.23484 20.9995 4.50002 21H19.5C19.7654 21 20.0261 20.9295 20.2554 20.7959C20.4847 20.6622 20.6744 20.4701 20.8052 20.2391C20.936 20.0081 21.0031 19.7466 20.9998 19.4812C20.9965 19.2158 20.9228 18.9561 20.7863 18.7284H20.7835ZM12.3385 14.7056C10.8469 13.9509 9.42752 13.5506 8.09908 13.5047L10.3931 9.67969C10.4633 9.56342 10.5003 9.43016 10.5 9.29437V3.75H13.5V9.29437C13.4998 9.43016 13.5368 9.56342 13.6069 9.67969L17.19 15.6562C16.0688 15.8756 14.4647 15.7819 12.3385 14.7056Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestFlask);
export default __webpack_public_path__ + "static/media/test-flask.095d453080e5f520b6604022097463ee.svg";
export { ForwardRef as ReactComponent };